import { ExternalApi } from "@/features/external-api-connections";

function SettingsPage() {
    return (
        <div className="basicWrapper">
            {/* <UnderDevelopment featureName="Settings page" /> */}
            <ExternalApi />
        </div>
    )
}

export default SettingsPage;